define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/ViewRef",
	"csi/xml",
	"./AggregateIncrementSizesMixin"
], function(declare,lang,ViewRef,xml,AggregateIncrementSizesMixin) {

	return declare(AggregateIncrementSizesMixin, {

		getAggregateSizesViewRef: function() {
			return lang.mixin(new ViewRef(), {
				m_url: this.getNode().$URL,
				m_id: "Sizes"
			});
		},

		toWriter: function() {
			// summary: write request to server on selecting BaseSize
			var	increment = this.getNode();
			var	urlOldBaseSize = this.getCurrentBaseSizeUrl(increment);
			var urlBaseSize = this.newValue || this.getFormData().getSelectedNode(true).$URL;

			// write request if change was made
			if (urlBaseSize && (urlBaseSize != urlOldBaseSize)) {
				this._writeRequest()
					.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlNode)
					.addParameter("SizeRangeURL", xml.ATTR_REF, this.getCurrentSizeRangeUrl(increment))
					.addParameter("BaseSizeURL", xml.ATTR_REF, urlBaseSize);

				this.setProgress();
			}
		}
	});
});